"use client";
import useSWR from "swr";

export type YoutubeStats = {
  channelId: string;
  title: string | null;
  handle: string | null;
  thumbnail: string | null;
  subscriberCount: number | null;
  videoCount: number;
  viewCount: number;
  hiddenSubscriberCount: boolean;
  fetchedAt: string;
};

const fetcher = (u: string) => fetch(u).then(r => r.json());

export function useYoutubeStats({ handle, channelId }:{ handle?: string; channelId?: string }) {
  const qp = channelId ? `channelId=${channelId}` : `handle=${encodeURIComponent(handle || "")}`;
  const { data, error, isLoading } = useSWR<YoutubeStats>(`/api/youtube-stats?${qp}`, fetcher, {
    refreshInterval: 5 * 60 * 1000, // optional; update every 5 min
    revalidateOnFocus: false,
  });
  return { data, error, isLoading };
}

export function formatCompact(n: number | null | undefined) {
  if (n == null) return "—";
  return Intl.NumberFormat("en-US", { notation: "compact", maximumFractionDigits: 1 }).format(n);
}